import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tooltip } from 'antd';
import systemConfig from '../../../../config/systematic';
import getList from '../../../universal/getList';


import WebUniversalReport, { WUExtendPropsType } from '../../../system/WebUniversalReport';
import dayjs from 'dayjs';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../../App';
import DownloadExcel from '../../../report/DownloadExcel';
import fetchApi from '../../../../utils/api/fetchApi';


const { RangePicker } = DatePicker;
export default function WarningProduct() {
    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const notificationApi = useNotificationInstance()
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    const [paRows, setPaRows] = useState<Array<any>>([])
    const [entrepotName, setEntrepotName] = useState<string>("所有");
    const [entrepotData, setEntrepotData] = useState<any>();
    const [form] = Form.useForm();
     const [isLoading, setIsLoading] = useState<boolean>(false)
   
    const [stateData,setStateData]=useState<Array<any>>(
        [
            {id:1,name:"超过"},
            // {id:2,name:"正常"},
            {id:2,name:"小于"},

        ]
    )

    const [initValues, setInitValues] = useState<any>();
    const changeEntrepot = (e: any, option: any) => {

        let entrepotName: Array<any> = []
        for (let i = 0; i < option.length; i++) {
            entrepotName.push(option[i].entrepotName)
        }


        setEntrepotName(entrepotName.join(","))

    }

    /** 表头内容 */
    let columnsHead: any = [
        {
            title: "编号",
            header: "编号",
            width: "10",
            dataIndex: "id",
            key: "id",

            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 6) + '....' : text)
                    : ''
            }</Tooltip>
            // render: (text: any) => (text ? text.selfId ? text.selfId : "" : "")
        },
        {
            title: "单号",
            header: "单号",
            width: "10",
            dataIndex: "orderId",
            key: "orderId",

            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 6) + '....' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: "日期",
            header: "日期",
            key: "createdAt",
            width: "10",
            dataIndex: "createdAt",
            align: "center",

            // render: (val: any, record: any) =>
            //     <span>
            //         {moment(val).format('YYYY-MM-DD')}
            //     </span>,

        },
        {
            title: "品号",
            header: "品号",
            dataIndex: "selfId",
            key: "selfId",

        },

        {
            title: "品名",
            header: "品名",
            dataIndex: "productName",
            width: "20",

            key: "productName",

        },
        {
            title: "单位",
            header: "单位",

            dataIndex: "productUnitName",
            key: "productUnitName",

        },
        {
            title: "规格",
            header: "规格",

            dataIndex: "productSpecifications",
            key: "productSpecifications",

        },
        {
            title: "数量",
            header: "数量",
            dataIndex: "bNum",
            key: "bNum",

            align: "center",

            render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        {
            title: "标价",
            header: "标价",

            dataIndex: "standardPrice",
            key: "standardPrice",

            align: "center",

            render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        {
            title: "上浮率",
            header: "上浮率",

            dataIndex: "floatingRange",
            key: "floatingRange",

            align: "center",

            // render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        {
            title: "最大单价",
            header: "最大单价",
            width: "10",
            dataIndex: "maxStandardPrice",
            key: "maxStandardPrice",

            align: "center",

            render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        // 
       
      
        {
            title: "单价",
            header: "单价",

            dataIndex: "univalence",
            key: "univalence",
            align: "center",
            render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        {
            title: "金额",
            header: "金额",

            dataIndex: "totalPrice",
            key: "totalPrice",

            align: "center",

            render: (text: any) => (text ? Number(text).toFixed(2) : 0)
        },
        {
            title: "差额",
            header: "差额",
            dataIndex: "difference1",
            key: "difference1",
            align: "center",
            // render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        {
            title: "进货比例",
            header: "进货比例",

            dataIndex: "differenceRate1",
            key: "differenceRate1",
            align: "center",
            // render: (text: any) => (text ? text.toFixed(2) : 0)
        },
        {
            title: "备注",
            header: "备注",
            dataIndex: "memo",
            key: "memo"
        },
    ];
    useEffect(() => {
        const fetchData = async () => {
            const entrepotRes = await fetchApi.GET(wmService, {
                apiId: 'entrepot',
                apiExtend: 'showListEx',
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            // isEmployees: true,
                            // isDept:true,
                            isUserEntrepots: true
                        }
                    },
                }
            });
            if (entrepotRes.success === true) {

                setEntrepotData(entrepotRes.data)
            }


        }
        fetchData()
    }, [])
    const onFinish = () => {
         setIsLoading(true)
        form.validateFields()
            .then((values: any) => {
                // initData(values)
                setInitValues({
                    ...values,
                    entrepotId: contextData?.currentEntrepotId,
                    time: values.chooseTime ? {
                        startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
                        endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
                    } : null,
                    mountDataOptions: {
                        userMount: {
                            isEmployees: true,
                            isDept: true,
                            isUserAreas: true
                        }
                    },

                })
                 setIsLoading(false)
            }).catch((err) => {
                 setIsLoading(false)
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            })



    }

    let extendProps: WUExtendPropsType = {
        apiId: 'entrepotReport',
        apiExtend: "warningProduct",
        columns: columnsHead,
        pagination: false,
        values: initValues,
        printType: "purchaseOrderPrint",
        typeProducts: "purchaseProducts",
        primaryKeyName: "orderId",
        printApi: "purchaseOrder",
        showOperation: false,
        showPrint: false,
        setPaRows
        // EditComponent: PurchaseOrderEdit,
    };
    return (
        <>
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={{ chooseTime: [dayjs().subtract(2, 'month'), dayjs()] }}
            >
                <Row>

                    <Col span={6}>
                        <Form.Item
                            label="日期"
                            name="chooseTime"
                        >
                            <RangePicker

                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            label="仓库"
                            name="entrepotIds"
                        >
                            <Select
                                mode="multiple"
                                fieldNames={{ value: "entrepotId", label: "entrepotName" }}
                                onChange={changeEntrepot}
                                allowClear
                                placeholder="仓库"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={entrepotData}
                            >
                                {/* {getList.general(entrepotData, 'entrepotName')} */}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="状态"
                            name="state"
                        >
                            <Select
                                fieldNames={{ value: "id", label: "name" }}
                                // onChange={changeEntrepot}
                                allowClear
                                placeholder="状态"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={stateData}
                            >
                                {/* {getList.general(entrepotData, 'entrepotName')} */}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={2}>
                        <Form.Item >
                            <Space>
                               <Button loading={isLoading} htmlType="submit">
                                    统计
                                </Button >
                                <Button onClick={() => DownloadExcel(paRows, "warningProduct", { columnsHead, entrepotName: entrepotName, })} >
                                    下载EXCEL文件
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>



            {/* <Button onClick={() => DownloadExcel(rows, "moonReport",queryCriteria)}>下载EXCEL文件</Button> */}
            {/* <div style={{ marginTop: "20px" }}>
        <Table
          // scroll={{ y: 750 }}
          pagination={paginationProps}
          rowKey={(record: any, index: any) => index}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>
        {modalPurOrderOpen ? (<PurchaseOrderEdit data={purOrderData} closeModal={onClosePurOrderOpen}
        />)
          : null}
      </div> */}
            <WebUniversalReport props={extendProps}></WebUniversalReport>
        </>
    )
}

